
var url = window.location.href;
var base_url = new URL(url).origin;

export const environment = {
    production: true,
    //apiBaseUrl: `https://mapsofterp.in/mapsoft-erp-webapi/api`,
    apiBaseUrl: `https://mapsoftsolutions.com/erpwebapi/api`,
    defaultTenant: 'default'
};
